import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { formatINR } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Minus, Plus, Trash2, MessageCircle } from "lucide-react";
import { openWhatsApp } from "@/lib/whatsapp";

export default function CartPage() {
  const { items, setQty, removeItem, subtotal, lines } = useCart();
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        <h1 className="font-serif text-3xl font-bold text-forest-dark">Your cart is empty</h1>
        <Link to="/"><Button className="mt-6 bg-forest text-cream rounded-full h-11 px-6">Start Shopping</Button></Link>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-serif text-3xl font-bold text-forest-dark mb-8">Your Cart</h1>
      <div className="grid lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2 space-y-4">
          {items.map((i) => (
            <div key={i.sku} className="flex gap-4 bg-white rounded-2xl p-4 border border-forest/10">
              <img src={i.image} alt={i.name} className="h-24 w-24 rounded-xl object-cover" loading="lazy" />
              <div className="flex-1">
                <p className="font-semibold text-charcoal">{i.name}</p>
                <p className="text-sm text-charcoal/60">{i.pack_size}</p>
                <p className="text-forest font-bold mt-1">{formatINR(i.price)}</p>
              </div>
              <div className="flex flex-col items-end justify-between">
                <button onClick={() => removeItem(i.sku)} className="text-charcoal/40 hover:text-discount"><Trash2 size={18} /></button>
                <div className="flex items-center border border-forest/20 rounded-full">
                  <button onClick={() => setQty(i.sku, i.quantity - 1)} className="p-2"><Minus size={14} /></button>
                  <span className="w-8 text-center font-semibold">{i.quantity}</span>
                  <button onClick={() => setQty(i.sku, i.quantity + 1)} className="p-2"><Plus size={14} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white rounded-2xl p-6 border border-forest/10 h-fit sticky top-24">
          <div className="flex justify-between mb-2"><span className="text-charcoal/70">Subtotal</span><span className="font-bold text-forest-dark">{formatINR(subtotal)}</span></div>
          <p className="text-xs text-charcoal/50 mb-4">Delivery & discounts calculated at checkout.</p>
          <Button onClick={() => navigate("/checkout")} data-testid="cart-page-checkout" className="w-full bg-forest hover:bg-forest-dark text-cream rounded-full h-12 font-semibold">Proceed to Checkout</Button>
          <Button onClick={() => openWhatsApp({ items: lines })} variant="outline" className="w-full mt-2 border-whatsapp text-whatsapp rounded-full h-11 font-semibold">
            <MessageCircle size={18} className="mr-2" /> Order on WhatsApp
          </Button>
        </div>
      </div>
    </div>
  );
}
